import { AreaChartCard } from 'componets/ui';

import { getInvestment } from 'features/statement/actions';

import { useAppSelector, useTranslate } from 'hooks';

import Utils from 'utils/utils';

export const Investment = () => {
	const investment = useAppSelector((state) => state.statement.investment);

	const { investmentText } = useTranslate(['investmentText']);

	return (
		<AreaChartCard
			subtitle={Utils.moneyFormat(+investment.total)}
			data={investment.items}
			getData={getInvestment}
			title={investmentText}
			isInvestment
		/>
	);
};
